import HTTP from '@/plugins/axios';

export type PrivacyPolicyParams = {
  lang: string
  type: string
  sid: string
};

export type PrivacyPolicyResponse = {
  text?: string
};

export const privacyPolicy = async(params: PrivacyPolicyParams) => {
  const response = await HTTP.get('/user/privacy_policy', { params });
  return response.data as PrivacyPolicyResponse;
};
